import Filters from '../util/Filters'
import Block from './Block'

export default class FilterProducts extends Block {
  onEnterCompleted() {
    this.limit = 21
    this.url = `type=product&limit=${this.limit}`

    if (this.filters.dataset.id && this.filters.dataset.type) this.url += `&${this.filters.dataset.type}=${this.filters.dataset.id}`

    this.init()
  }

  bindMethods() {
    super.bindMethods()

    this.onSubmit = this.onSubmit.bind(this)
    this.onFetch = this.onFetch.bind(this)
    this.loadMore = this.loadMore.bind(this)
  }

  getElems() {
    super.getElems()

    this.filters = this.el.querySelector('.shop__list-filters')
    this.list = this.el.querySelector('.shop__list-cards')
    this.loadButton = this.el.querySelector('.shop__list-more')
    this.overlay = this.el.querySelector('.shop__list-overlay')
  }

  events() {
    super.events()

    this.loadButton.addEventListener('click', this.loadMore)
  }

  init() {
    this.filter = new Filters({
      el: this.filters,
      args: this.filters.dataset.type && this.filters.dataset.id ? `&${this.filters.dataset.type}=${this.filters.dataset.id}` : '',
      type: 'product',
      limit: this.limit,
      submit: this.onSubmit,
      fetch: this.onFetch
    })
  }

  onSubmit() {
    this.overlay.classList.add('active')
  }

  onFetch(results, url, page) {
    if (page === 0) this.list.innerHTML = ''

    this.url = url
    results.forEach((result) => this.createCard(result))

    this.loadButton.classList.toggle('hide', results.length < this.limit)
    this.overlay.classList.remove('active')
  }

  loadMore() {
    if (!this.url) return

    this.overlay.classList.add('active')
    this.filter.fetchPosts(this.url, true)
  }

  createCard(data) {
    let html = ''
    let srcset = ''
    const col = document.createElement('div')

    col.classList.add('col-lg-8', 'mt10')

    html += `<a href="${data.link}" class="card-product" aria-label="${data.title}">`
    if (data.labels) {
      html += '<div class="card-product__labels">'
      html += '<div class="card-product__label">'
      html += '<div class="card-product__label-image">'
      html += '<div class="image">'
        if (data.labels[0].image) {
          Object.entries(data.labels[0].image.srcset).forEach(([key, value]) => {
            srcset += `${value} ${key}, `
          })

          html += '<picture>'
          html += `<img src="${data.labels[0].image.url}" alt="${data.labels[0].image.alt}" data-srcset="${srcset}" srcset="${srcset}">`
          html += '</picture>'
        }
      srcset = ''
      html += '</div>'
      html += '</div>'
      html += `<div class="card-product__label-text">${data.labels[0].text}</div>`
      html += '</div>'
      html += '<div class="card-product__label">'
      html += '<div class="card-product__label-image">'
      html += '<div class="image">'
        if (data.labels[1].image) {
          Object.entries(data.labels[1].image.srcset).forEach(([key, value]) => {
            srcset += `${value} ${key}, `
          })

          html += '<picture>'
          html += `<img src="${data.labels[1].image.url}" alt="${data.labels[1].image.alt}" data-srcset="${srcset}" srcset="${srcset}">`
          html += '</picture>'
        }
      srcset = ''
      html += '</div>'
      html += '</div>'
      html += `<div class="card-product__label-text">${data.labels[1].text}</div>`
      html += '</div>'
      html += '</div>'
    }
    html += '<div class="card-product__image">'
    html += '<div class="image">'
    if (data.image) {
      Object.entries(data.image.srcset).forEach(([key, value]) => {
        srcset += `${value} ${key}, `
      })

      html += '<picture>'
      html += `<img src="${data.image.url}" alt="${data.image.alt}" data-srcset="${srcset}" srcset="${srcset}">`
      html += '</picture>'
    }
    html += '</div>'
    html += '</div>'
    html += `<h3 class="card-product__title">${data.title}</h3>`
    if (data.brand) {
      html += `<div class="card-product__brand">${data.brand}</div>`
    }
    if (data.short_description.length > 80) {
      data.short_description = data.short_description.substr(0, 80) + '...'
    }
    data.short_description = data.short_description.replace(/(<([^>]+)>)/gi, '')
    html += `<div class="card-product__excerpt">${data.short_description}</div>`
    html += '</a>'

    col.innerHTML = html
    this.list.appendChild(col)
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/FilterProducts.js